'use client';
import useNavigate from '@/hooks/useNavigate';
import { confirmRegisterFromEmailLink } from '@/services/register';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

const ConfirmEmail = () => {
  const navigate = useNavigate();
  const [accountConfirmed, setAccountConfirmed] = useState('pending');
  const [message, setMessage] = useState(
    'Veuillez patienter pendant que nous confirmons votre compte d\'acc&egrave;s.'
  );
  const searchParams = useSearchParams();
  const userId = decodeURIComponent(searchParams.get('userId'));
  const token = decodeURIComponent(searchParams.get('token'));

  const confirmAccountWithApi = async (userId, token) => {
    try {
      const data = await confirmRegisterFromEmailLink(userId, token);
      if (data instanceof Error) {
        setAccountConfirmed('error');
        setMessage(
          data.message ||
          'Une erreur s\'est produite lors de la confirmation de votre compte d\'accès.'
        );
      } else {
        setAccountConfirmed('success');
        setTimeout(() => {
          navigate('/achats');
        }, 3456);
        setMessage(
          'Votre compte d\'accès a été confirmé avec succès. Vous pouvez maintenant vous connecter.'
        );
      }
    } catch (error) {
      console.error(error);
      setAccountConfirmed('error');
      setMessage(
        'Une erreur s\'est produite lors de la confirmation de votre compte d\'accès.'
      );
    }
  };

  useEffect(() => {
    if (userId && token) {
      confirmAccountWithApi(userId, token);
    }
  }, [userId, token]);

  return accountConfirmed === 'success' ? (
    <div className="text-center container">
      <h1>Confirmation d&apos;inscription</h1>
      <p></p>
      <p>Merci d&apos;avoir confirm&eacute; votre compte d&apos;acc&egrave;s.</p>
      <p>Vous serez automatiquement rediriger dans 5 secondes.</p>
      <br/>
    </div>
  ) : (
    <div className="text-center container">
      <h1>Confirmation d&apos;inscription</h1>
      <p></p>
      <p>{message}</p>
      <br/>
    </div>
  );
};

export default ConfirmEmail;
